import { render, staticRenderFns } from "./NewsCategories.vue?vue&type=template&id=24ad6b84"
import script from "./NewsCategories.vue?vue&type=script&lang=js"
export * from "./NewsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports